import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

const NavBar = () => {
	const modalOpener = () => {
		const item = document.getElementById('btn-modal');
		item.click();
	};
	const useKeyEnter = (e) => {
		if (e.keyCode === 13) e.target.click();
	};
	return (
		<div className="navbar">
			<div className="navbar--right">
				<a href="https://blog.barisozcetin.me" className="navbar__link">
					Blog
				</a>
				<ScrollLink
					onKeyDown={useKeyEnter}
					tabIndex="0"
					className="navbar__link"
					to="about"
					smooth={true}
					duration={500}
				>
					About
				</ScrollLink>
				<ScrollLink
					onKeyDown={useKeyEnter}
					tabIndex="0"
					to="portfolio"
					className="navbar__link"
					smooth={true}
					duration={500}
				>
					Portfolio
				</ScrollLink>
				<a role="button" onKeyDown={useKeyEnter} tabIndex="0" className="navbar__link" onClick={modalOpener}>
					Contact
				</a>
			</div>
		</div>
	);
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/common/NavBar.js